export enum GroupUserStatusEnum {
    ALL = -1,
    JOINED = 0,
    NOT_JOINED,
    DELETED,
}

export const groupStatusNames: Record<GroupUserStatusEnum, string> = {
    [GroupUserStatusEnum.ALL]: 'status.all',
    [GroupUserStatusEnum.JOINED]: 'groups.status.joined',
    [GroupUserStatusEnum.NOT_JOINED]: 'groups.status.notJoined',
    [GroupUserStatusEnum.DELETED]: 'groups.status.deleted',
};
